function truncate (width) {
  return `
    ${width && `width: ${width}px`};
    ${width && `max-width: ${width}px`};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `
}

function rgba (hex, alpha) {
  hex = parseInt(hex.slice(1), 16)
  var r = hex >> 16
  var g = (hex >> 8) & 0xff
  var b = hex & 0xff
  return `rgba(${[r, g, b, alpha].join(',')})`
}

export default {
  truncate,
  rgba
}
